export default __webpack_public_path__ + "static/media/standsExpo_petroleo.dfbc36fd.jpg";